import { c as _c } from "react/compiler-runtime";
import { ContentCard, type ImageComponent } from "fansunited-sports-ui";
import { FillImage } from "@/components/ui/FillImage";
import type { PostGridProps } from "./types";

/**
 * Minimal variant: Horizontal cards with title and image (list view)
 */
export function PostGridMinimal(t0) {
  const $ = _c(17);
  const {
    posts,
    title,
    formatDate,
    getImageUrl,
    className,
    buildLink
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = title && <h2 className="text-2xl font-bold mb-6">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== buildLink || $[3] !== formatDate || $[4] !== getImageUrl || $[5] !== posts) {
    let t3;
    if ($[7] !== buildLink || $[8] !== formatDate || $[9] !== getImageUrl) {
      t3 = post => <ContentCard key={post.id} content={{
        id: String(post.id),
        type: post.type === "video" ? "video" : "article",
        link: buildLink(post),
        title: post.title,
        image: {
          url: getImageUrl(post.heroImage) || "",
          alt: post.title
        },
        metadata: {
          time: formatDate(post.publishedAt)
        }
      }} variant="standardHorizontal" ImageComponent={FillImage as ImageComponent} styles={{
        mainIconSize: "sm",
        typography: {
          title: "text-base font-semibold"
        }
      }} />;
      $[7] = buildLink;
      $[8] = formatDate;
      $[9] = getImageUrl;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = posts.map(t3);
    $[2] = buildLink;
    $[3] = formatDate;
    $[4] = getImageUrl;
    $[5] = posts;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[11] !== t2) {
    t3 = <div className="flex flex-col gap-4">{t2}</div>;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== className || $[14] !== t1 || $[15] !== t3) {
    t4 = <section className={className}>{t1}{t3}</section>;
    $[13] = className;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}